import { Heart } from 'lucide-react';

interface HeartsDisplayProps {
  hearts: number;
  max?: number;
}

export function HeartsDisplay({ hearts, max = 5 }: HeartsDisplayProps) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: max }).map((_, i) => (
        <Heart
          key={i}
          className={`w-5 h-5 transition-colors ${
            i < hearts
              ? 'fill-destructive text-destructive'
              : 'fill-muted text-muted-foreground/30'
          }`}
        />
      ))}
    </div>
  );
}
